import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Layout from 'components/layout/index.vue';

import { systemSetting } from './systemSetting';
import { finance } from './finance';
import { document } from './document';
import { data } from './data';
import { kp } from './kp';
import { humint } from './humint';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
      meta: {
        title: '天池投资管理系统-登录'
      }
    },
    {
      path: '/pdfview',
      component: () => import(/* webpackChunkName: "pdfview" */ '@/views/pdfview.vue'),
      meta: {
        title: '天池投资管理系统-文档阅读'
      }
    },
    {
      path: '/pdfview/:type',
      component: () => import(/* webpackChunkName: "pdfview" */ '@/views/pdfview.vue'),
      meta: {
        title: '天池投资管理系统-文档阅读'
      }
    },
    {
      path: '/project/meetingAudio',
      component: () => import(/* webpackChunkName: "voteRecords" */ '@/views/project/meetingAudio.vue'),
      meta: {
        title: '天池投资管理系统-会议录音'
      }
    },
    {
      path: '/search',
      component: () => import(/* webpackChunkName: "search" */ '@/views/search.vue'),
      meta: {
        title: '天池投资管理系统-搜索'
      }
    },
    {
      path: '/notify',
      component: () => import(/* webpackChunkName: "search" */ '@/views/notifyList.vue'),
      meta: {
        title: '天池投资管理系统-通知'
      }
    },
    {
      path: '/500',
      component: () => import(/* webpackChunkName: "error" */ '@/views/500.vue')
    },
    {
      path: '/403',
      component: () => import(/* webpackChunkName: "error" */ '@/views/403.vue')
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "error" */ '@/views/404.vue')
    },
    {
      path: '',
      component: Layout,
      redirect: '/',
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue'),
          meta: {
            title: '天池投资管理系统-首页'
          }
        },
        {
          path: '/data',
          component: () => import(/* webpackChunkName: "data" */ '@/views/data/index.vue'),
          children: data,
          meta: {
            title: '天池投资管理系统-数据'
          }
        },
        {
          path: '/kp',
          component: () => import(/* webpackChunkName: "kp" */ '@/views/kp/index.vue'),
          children: kp,
          meta: {
            title: '天池投资管理系统-客户'
          }
        },
        {
          path: '/person',
          component: () => import(/* webpackChunkName: "person" */ '@/views/person.vue'),
          meta: {
            title: '天池投资管理系统-个人工作进展'
          }
        },
        {
          path: '/project',
          component: () => import(/* webpackChunkName: "project" */ '@/views/project/list.vue'),
          meta: {
            title: '天池投资管理系统-项目'
          }
        },
        {
          path: '/project/detail',
          component: () => import(/* webpackChunkName: "projectDetail" */ '@/views/project/detail.vue'),
          meta: {
            title: '天池投资管理系统-项目'
          }
        },
        {
          path: '/project/voteRecords',
          component: () => import(/* webpackChunkName: "voteRecords" */ '@/views/project/voteRecords.vue')
        },
        {
          path: '/project/meetingList',
          component: () => import(/* webpackChunkName: "project_meetingList" */ '@/views/project/meetingList.vue'),
          meta: {
            title: '天池投资管理系统-会议'
          }
        },
        {
          name: 'votePage',
          path: '/project/votePage',
          component: () => import(/* webpackChunkName: "votePage" */ '@/views/project/votePage.vue')
        },
        {
          name: 'round',
          path: '/project/round',
          component: () => import(/* webpackChunkName: "votePage" */ '@/views/project/round.vue'),
          meta: {
            title: '天池投资管理系统-项目'
          }
        },
        {
          path: '/meeting',
          component: () => import(/* webpackChunkName: "meeting" */ '@/views/meeting/index.vue'),
          redirect: '/meeting/list',
          children: [
            {
              path: '/meeting/list',
              component: () => import(/* webpackChunkName: "meetingList" */ '@/views/meeting/list.vue')
            },
            {
              path: '/meeting/createMeeting',
              component: () => import(/* webpackChunkName: "meetingCreate" */ '@/views/meeting/createMeeting.vue')
            }
          ],
          meta: {
            title: '天池投资管理系统-会议'
          }
        },
        {
          path: '/meeting/suggestParticipates',
          component: () => import(/* webpackChunkName: "suggestParticipates" */ '@/views/meeting/suggestParticipates.vue'),
          meta: {
            title: '天池投资管理系统-会议'
          }
        },
        {
          path: '/meeting/detail',
          component: () => import(/* webpackChunkName: "metingDetail" */ '@/views/meeting/detail.vue'),
          meta: {
            title: '天池投资管理系统-会议'
          }
        },
        {
          path: '/document',
          component: () => import(/* webpackChunkName: "document" */ '@/views/document/index.vue'),
          children: document,
          meta: {
            title: '天池投资管理系统-文档'
          }
        },
        {
          path: '/systemSetting',
          redirect: systemSetting[0].path,
          component: () => import(/* webpackChunkName: "systemSettingIndex" */ '@/views/systemSetting/index.vue'),
          children: systemSetting,
          meta: {
            title: '天池投资管理系统-设置'
          }
        },
        {
          path: '/finance',
          // redirect: finance[0].path,
          component: () => import(/* webpackChunkName: "financeIndex" */ '@/views/finance/index.vue'),
          children: finance,
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        {
          path: '/legal/index',
          component: () => import(/* webpackChunkName: "legalIndex" */ '@/views/legal/index.vue'),
          children: finance
        },
        // 基金管理-fundchart
        {
          path: '/finance/fundManage/fundChart',
          component: () => import(/* webpackChunkName: "fundChart" */ '@/views/finance/fundManage/fundChart.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // 基金管理-fundchart
        {
          path: '/finance/fundManage/list',
          component: () => import(/* webpackChunkName: "fundManageList" */ '@/views/finance/fundManage/list.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // 财务-交易数据中间页详情
        {
          path: '/finance/middlePage/detail',
          component: () => import(/* webpackChunkName: "middlePageDetail" */ '@/views/finance/middlePage/detail.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // 财务-交易数据中间页详情-新增/编辑退出记录
        {
          path: '/finance/middlePage/detail/exit',
          component: () => import(/* webpackChunkName: "middlePageDetailExit" */ '@/views/finance/middlePage/exitConfig.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // 财务-交易数据中间页详情-新增/编辑交易记录
        {
          path: '/finance/middlePage/detail/deal',
          component: () => import(/* webpackChunkName: "middlePageDetailDeal" */ '@/views/finance/middlePage/dealConfig.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // 财务-交易数据中间页详情-新增/编辑事件
        {
          path: '/finance/middlePage/detail/event',
          component: () => import(/* webpackChunkName: "middlePageDetailEvent" */ '@/views/finance/middlePage/eventConfig.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // /财务-交易数据中间页/数据字典 并没有找到入口
        {
          path: '/finance/middlePage/dataDictionary',
          component: () => import(/* webpackChunkName: "middlePageDataDictionary" */ '@/views/finance/middlePage/dataDictionary.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        },
        // 财务-交易数据中间页历史数据切片
        {
          path: '/finance/middlePage/historySlice',
          component: () => import(/* webpackChunkName: "middlePageHistorySlice" */ '@/views/finance/middlePage/historySlice.vue'),
          meta: {
            title: '天池投资管理系统-北冥'
          }
        }
      ]
    },
    {
      path: '/kp/seed/search',
      redirect: humint.path,
      component: () => import(/* webpackChunkName: "kpSearch" */ '@/views/kp/search.vue')
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "error" */ '@/views/404.vue')
    },
    humint
  ]
});

export default router;
